import React, { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import Navbar from '../common/Navbar';
import Footer from '../common/Footer';
import { WelcomeModal } from '../WelcomeModal';
import CookieBanner from '../CookieBanner';

const Layout = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    console.log('Layout mounted, setting timer for modal');
    const timer = setTimeout(() => {
      console.log('Timer finished, opening modal');
      setIsModalOpen(true);
    }, 1500);

    return () => {
      console.log('Cleaning up timer');
      clearTimeout(timer);
    };
  }, []);

  const handleCloseModal = () => {
    console.log('Closing modal');
    setIsModalOpen(false);
  };

  return (
    <div className="min-h-screen flex flex-col bg-primary-50">
      <WelcomeModal isOpen={isModalOpen} onClose={handleCloseModal} />
      <Navbar />
      <main className="flex-grow">
        <Outlet />
      </main>
      <Footer />
      <CookieBanner />
    </div>
  );
};

export default Layout; 